import React from "react";
import styled from "styled-components";
import { Field, ErrorMessage } from "formik";

import { BlankLink } from "../Shared";
import DropDownArrow from "./dropdown.svg";
import { colors, device, fonts, fontWeights } from "../App/StyleVariables";

export const FieldContainer = styled.div`
  border-bottom-width: 1px;
  border: 0.0625rem rgba(191, 191, 191, 0.5) solid;
  color: ${colors.grey};
  float: left;
  font-family: ${fonts.museo};
  letter-spacing: 0.03125rem;
  line-height: 1.5rem;
  margin: 0 0.3125rem 0.625rem;
  position: relative;
  transition: color 0.25s, padding-bottom 0.25s;
  width: 100%;

  &::after {
    background-color: ${props => (props.error ? colors.warning : colors.white)};
    bottom: 0;
    content: "";
    height: ${props => (props.error ? "100%" : "0%")};
    left: 0;
    position: absolute;
    transition: height 0.25s;
    width: 0.1875rem;
  }
`;

export const FieldLabel = styled.label`
  box-sizing: border-box;
  color: ${colors.grey};
  font-size: 0.6875rem;
  font-weight: ${fontWeights.medium};
  left: 1.25rem;
  pointer-events: none;
  position: absolute;
  top: 0.6875rem;
  transition: top 0.1s ease;

  span {
    color: ${colors.warning};
    padding-left: 0.625rem;
  }
`;

export const FieldWrap = styled(Field)`
  appearance: none;
  background-color: ${colors.white};
  border: 0;
  border-radius: 0;
  color: ${colors.mediumBlue};
  display: block;
  font-family: ${fonts.museo};
  font-size: 0.875rem;
  font-weight: ${fontWeights.light};
  min-height: 4.0625rem;
  padding: 1.9375rem 1.25rem 0.625rem;
  width: 100%;

  &::placeholder,
  &[type="select"]:invalid {
    color: ${colors.lightGrey};
  }

  &[type="select"] {
    background-image: url(${DropDownArrow});
    background-repeat: no-repeat;
    background-position: 96% 66%;

    @media ${device.sm} {
      background-position: 94% 66%;
    }
  }
`;

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 58rem;

  @media ${device.sm} {
    flex-direction: row;
  }

  @media ${device.md} {
    div:first-child {
      width: 160%;
    }
  }
`;

export const Button = styled.button`
  background-color: ${props => (props.disabled ? "#bfbfbf" : colors.orange)};
  border-radius: 0.3125rem;
  border: 0;
  box-sizing: border-box;
  color: ${props => (props.disabled ? "#F7F7F7" : colors.white)};
  cursor: ${props => (props.disabled ? "default" : "pointer")};
  display: inline-block;
  font-family: ${fonts.brandon};
  font-size: 1rem;
  font-weight: ${fontWeights.bold};
  letter-spacing: 0.16em;
  margin: 0 0.3125rem 0.625rem;
  padding: 0.8125rem;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: border-color 0.2s, background-color 0.2s, color 0.2s;
  width: 100%;

  &:hover {
    background-color: ${props =>
      props.disabled ? "#bfbfbf" : colors.orangeDark};
  }

  @media ${device.sm} {
    max-width: 8rem;
  }
`;

export const StyleInput = ({
  errors,
  touched,
  name,
  label,
  type = "text",
  component = "input",
  placeholder = "",
  required = false,
  children
}) => (
  <FieldContainer error={errors[name] && touched[name]}>
    <FieldLabel htmlFor={name}>
      {label}
      <ErrorMessage name={name} component="span" />
    </FieldLabel>
    <FieldWrap
      component={component}
      name={name}
      placeholder={placeholder}
      required={required}
      type={type}
    >
      {children}
    </FieldWrap>
  </FieldContainer>
);

const PrivacyWrap = styled.div`
  margin: 1rem auto 0;
  max-width: 10rem;

  a {
    color: ${colors.white};
  }
`;

export const PrivacyLink = () => (
  <PrivacyWrap>
    <BlankLink
      href="https://www.harrys.com/privacy-policy"
      children="Privacy Policy"
    />
  </PrivacyWrap>
);
